<div class="knowledge-container">
  <div class="tabs">
    <button 
      class="tab-button" 
      [class.active]="activeTab === 'hot_topics'" 
      (click)="selectTab('hot_topics')">
      HOT TOPICS
    </button>
    <button 
      class="tab-button" 
      [class.active]="activeTab === 'menu'" 
      (click)="selectTab('menu')">
      MENU
    </button>
  </div>

  <div class="content">
    <div *ngIf="activeTab === 'hot_topics'" class="list-container">
      <div *ngFor="let item of (hotTopics$ | async)" class="list-item hot-topic-item" (click)="onHotTopicClick(item)">
        <img [src]="baseUrl + item.field_cover_image" alt="" class="item-icon">
        <div class="item-text">
          <div class="item-title">{{ decode(item.title) }}</div>
          <div class="item-description">{{ decode(item.field_short_description) }}</div>
        </div>
        <div class="item-age" *ngIf="item.field_age_group">{{ item.field_age_group }}</div>
      </div>
    </div>

    <div *ngIf="activeTab === 'menu'">
      <button *ngIf="level !== 'top'" (click)="goBack()" class="back-button">Back</button>

      <div [ngSwitch]="level">
        <div *ngSwitchCase="'top'" class="list-container">
          <div *ngFor="let item of (displayItems$ | async)" class="list-item menu-item" (click)="onMenuItemClick(item)">
            <img [src]="baseUrl + item.field_icon_image" alt="" class="item-icon-large">
            <div class="item-text">
              <div class="item-title">{{ decode(item.name) }}</div>
              <div class="item-description" [innerHTML]="item.description__value_export"></div>
            </div>
            <span class="arrow">></span>
          </div>
        </div>

        <div *ngSwitchCase="'sub'" class="list-container">
          <div *ngFor="let item of (displayItems$ | async)" class="list-item menu-item" (click)="onSubMenuItemClick(item)">
            <img [src]="baseUrl + item.field_icon_image" alt="" class="item-icon-large">
            <div class="item-text">
              <div class="item-title">{{ decode(item.name) }}</div>
              <div class="item-description" [innerHTML]="item.description__value_export"></div>
            </div>
            <span class="arrow">></span>
          </div>
        </div>

        <div *ngSwitchCase="'content'" class="list-container">
          <div *ngFor="let item of (displayItems$ | async)
" class="list-item hot-topic-item" (click)="goToDetails(item)">
            <img [src]="baseUrl + item.field_cover_image" alt="" class="item-icon">
            <div class="item-text">
              <div class="item-title">{{ decode(item.title) }}</div>
              <div class="item-description">{{ decode(item.field_short_description) }}</div>
            </div>
            <div class="item-age" *ngIf="item.field_age_group">{{ item.field_age_group }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>